<template>
  <div id="app-edit-account">
    <VHeader :user="user" />
    <v-card class="user-data">
      <v-card-text>
        <v-flex>
          <v-text-field
            id="name"
            type="text"
            v-model="user.name"
            :label="$t('users_crud.name')"
            autocomplete="new-password"
            @keyup.enter="focus('current-password')"
            required
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-text-field
            id="current-password"
            v-model="currentPassword"
            type="password"
            :label="$t('users_crud.current_password')"
            autocomplete="new-password"
            @keyup.enter="focus('password')"
            required
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-text-field
            id="password"
            v-model="password"
            type="password"
            :label="$t('users_crud.password')"
            autocomplete="new-password"
            @keyup.enter="focus('repeat-password')"
            required
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-text-field
            id="repeat-password"
            v-model="repeatPassword"
            type="password"
            :label="$t('users_crud.repeat_password')"
            autocomplete="new-password"
            @keyup.enter="save"
            required
          ></v-text-field>
        </v-flex>
        <v-btn
          class="save-button"
          color="success"
          @click="save()"
          :disabled="blockSave"
        >{{$t('users_crud.save')}}</v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import VHeader from "../components/header.vue";
import User from "@/models/User.js";
export default {
  name: "app-edit-account",
  data() {
    return {
      currentPassword: "",
      password: "",
      repeatPassword: "",
      user: new User(this.$session.get("user"))
    };
  },
  computed: {
    blockSave() {
      if (this.currentPassword == "") {
        return true;
      }
      if (this.password == "") {
        return true;
      }
      if (this.repeatPassword == "") {
        return true;
      }
      if (this.password != this.repeatPassword) {
        return true;
      }
      return false;
    }
  },
  mounted(){
      this.focus('name');
  },
  methods: {
    async save() {
        if(this.blockSave){
            this.focus('current-password');
            return 0;
        }
        try {
          await User.login(this.user.email, this.currentPassword)
          await this.user.save({
            name: this.user.name,
            password: this.password
          });
          alert(this.$t('users_crud.succesfully_updated'))
        } catch {
          this.currentPassword = "";
          this.password = "";
          this.repeatPassword = "";
          this.focus('current-password');
          alert(this.$t("users_crud.wrong_password"));
        }
    },

    focus(component){
        document.getElementById(component).focus()
    }
  },
  components: {
    VHeader
  }
};
</script>

<style scoped>
.user-data {
  position: absolute;
  top: 100px;
  left: 50%;
  width: 90%;
  /* bring your own prefixes */
  transform: translate(-50%, 0);
}
.save-button {
  margin-top: 25px;
  width: 100%;
}
</style>